const muiModal = '@@muiModal/'
export const ADD_MODAL = `${muiModal}ADD_MODAL`
export const HIDE_MODAL = `${muiModal}HIDE_MODAL`
export const REMOVE_MODAL = `${muiModal}REMOVE_MODAL`
export const CONFIRMED = `${muiModal}CONFIRMED`
export const CANCELED = `${muiModal}CANCELED`
export const MODAL_ACTION = `${muiModal}MODAL_ACTION`
export const CLEAR_MODALS = `${muiModal}CLEAR_MODALS`
